import { useCallback, useMemo } from "react";
import { useMaterialUIController } from "context";
import {
  AccessRequirement,
  AccessSnapshot,
  accessFromUser,
  checkAccess,
} from "helpers/permissions";

export function useAccess(): AccessSnapshot & {
  canAccess: (requirement?: AccessRequirement | null) => boolean;
  hasPermission: (permission: string) => boolean;
  hasRole: (role: string) => boolean;
} {
  const [controller] = useMaterialUIController();
  const snapshot = useMemo(
    () => accessFromUser(controller.user),
    [controller.user]
  );

  const canAccess = useCallback(
    (requirement?: AccessRequirement | null) =>
      checkAccess(snapshot, requirement),
    [snapshot]
  );

  const hasPermission = useCallback(
    (permission: string) => snapshot.permissions.includes(permission),
    [snapshot.permissions]
  );

  const hasRole = useCallback(
    (role: string) => snapshot.roles.includes(role),
    [snapshot.roles]
  );

  return {
    ...snapshot,
    canAccess,
    hasPermission,
    hasRole,
  };
}
